// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3pfQn","large":"styles_large__gYVch"};